<p>couch-base-detalle-usuario works!</p>

 
  <form [formGroup]="usuarioForm" (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <label for="id" class="form-label">ID</label>
      <input type="number" id="id" class="form-control" formControlName="id" readonly >
    </div>
    <div class="mb-3">
      <label for="nombre" class="form-label">Nombre</label>
      <input type="text" id="nombre" class="form-control" formControlName="nombre">
    </div>
    <div class="mb-3">
      <label for="apellidos" class="form-label">Apellidos</label>
      <input type="text" id="apellidos" class="form-control" formControlName="apellidos">
    </div>
    <div class="mb-3">
      <label for="direccion" class="form-label">Dirección</label>
      <input type="text" id="direccion" class="form-control" formControlName="direccion">
    </div>
    <div class="mb-3">
      <label for="fxNacimiento" class="form-label">Fecha de nacimiento</label>
      <input type="text" id="fxNacimiento" class="form-control" formControlName="fxNacimiento">
    </div>
    <div class="mb-3">
      <label for="fxAlta" class="form-label">Fecha de alta</label>
      <input type="text" id="fxAlta" class="form-control" formControlName="fxAlta">
    </div>
    <div class="mb-3">
      <label for="fxModificacion" class="form-label">Fecha de modificacion</label>
      <input type="text" id="fxModificacion" class="form-control" formControlName="fxModificacion">
    </div>
    <button type="submit" class="btn btn-primary">Guardar</button>
    <button type="button" class="btn btn-danger" (click)="onDelete()">Borrar</button>
    <button type="button" class="btn btn-danger" (click)="onClean()">Limpiar</button>
  </form>




